export default window.__litium.constants;
export const DYNAMIC_FORM_GET = 'DYNAMIC_FORM_GET';
export const DYNAMIC_FORM_SENT_SUCCESS = 'DYNAMIC_FORM_SENT_SUCCESS';

export const DYNAMIC_FORM_RECEIVE = 'DYNAMIC_FORM_RECEIVE';
export const DYNAMIC_FORM_ERROR = 'DYNAMIC_FORM_ERROR';
export const DYNAMIC_FORM_DISPLAY_STATE = 'DYNAMIC_FORM_DISPLAY_STATE';
export const DYNAMIC_FORM_INFORMATION_SENT = 'DYNAMIC_FORM_INFORMATION_SENT';

export const STATUS_FORM_SENT_SUCCESS = 'STATUS_FORM_SENT_SUCCESS';
export const STATUS_FORM_ERROR = 'STATUS_FORM_ERROR';